import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.isOpen ? _c(VDialog, _vm._b({
    attrs: {
      "persistent": _vm.persistent,
      "scrollable": "",
      "max-width": String(_vm.maxWidth),
      "content-class": "n20-dialog-container"
    },
    on: {
      "click:outside": _vm.closeOnClickOutSide,
      "keydown": _vm.closeOnEscape
    },
    model: {
      value: _vm.isOpen,
      callback: function ($$v) {
        _vm.isOpen = $$v;
      },
      expression: "isOpen"
    }
  }, 'v-dialog', _vm.$attrs, false), [_c(VCard, [_c('div', {
    staticClass: "card-action-box"
  }, [_c('div', {
    staticClass: "card-action-box-bg px-2 n20-dialog-button-break-out"
  }, [_vm._t("buttons", function () {
    return _vm._l(_vm.buttons, function (item, i) {
      return _c('span', {
        key: i
      }, [_vm._t("singleButton", function () {
        return [item.title && !_vm.isMobile ? _c('core-button', {
          attrs: {
            "data-cy": item.dataCy,
            "color": item.color || _vm.color,
            "title": item.tooltip,
            "disabled": item.type === 'submit' && !_vm.formValue || !_vm.validStates[i] || _vm.cloading,
            "type": item.type === 'submit' ? 'submit' : 'button',
            "prepend-icon": item.icon,
            "href": item.href,
            "target": item.href && item.target
          },
          on: {
            "click": function ($event) {
              return _vm.exec(item.action);
            }
          }
        }, [_vm._v("\n                " + _vm._s(item.title) + "\n              ")]) : _c('core-button', {
          attrs: {
            "data-cy": item.dataCy,
            "color": item.color || _vm.color,
            "title": item.tooltip,
            "disabled": item.type === 'submit' && !_vm.formValue || !_vm.validStates[i] || _vm.cloading,
            "type": item.type === 'submit' ? 'submit' : 'button',
            "prepend-icon": item.icon,
            "href": item.href,
            "target": item.href && item.target
          },
          on: {
            "click": function ($event) {
              return _vm.exec(item.action);
            }
          }
        })];
      }, {
        "button": item
      })], 2);
    });
  }, {
    "buttons": _vm.buttons
  }), _vm.hasSaveListener ? _c('core-button', {
    attrs: {
      "data-cy": "save_create_dt",
      "color": _vm.color,
      "prepend-icon": "fa-save",
      "disabled": _vm.actionSaveDisabled !== false,
      "loading": _vm.actionSaveLoading !== false
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.$emit('action:save');
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.actionSaveLabel || _vm.$i18n_t('Common.save')) + "\n        ")]) : _vm._e(), _vm.hasCloseListener ? _c('core-button', {
    attrs: {
      "data-cy": "btn_dialog_close",
      "color": "danger",
      "prepend-icon": "fa-times"
    },
    on: {
      "click": _vm.closeDialog
    }
  }) : _vm._e()], 2)]), _vm.$slots.title || _vm.title ? _c(VCardTitle, [_c('h3', {
    class: `mt-2 mb-1 headline ${_vm.color}--text`,
    staticStyle: {
      "word-break": "break-word",
      "width": "100%"
    }
  }, [_vm._t("title", function () {
    return [_vm._v("\n          " + _vm._s(_vm.title) + "\n        ")];
  })], 2)]) : _vm._e(), _c(VCardText, [_vm._t("default")], 2), _vm.$slots.actions ? _c(VDivider, {
    staticClass: "mx-4"
  }) : _vm._e(), _vm.$slots.actions ? _c(VCardActions, [_vm._t("actions")], 2) : _vm._e()], 1)], 1) : _vm._e();
};
var staticRenderFns = [];
export { render, staticRenderFns };